module.exports = __webpack_public_path__ + "img/d04.721cbd7a.jpg";